import React from 'react';
import { Icon } from './Icon.js';
export const IconFolder = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M2 3V20H22V6H13L10 3H2Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconFolder.js.map